import { Link, Lead } from '@sbab-ui/components'
import SBABLogo from '../assets/SBAB_logo'


interface Props {
  variant?: 'light' | 'dark'
}

export default function AppHeader({ variant = 'light' }: Readonly<Props>) {
  const isDarkMode = variant === 'dark'

  return (
    <header
      className={`${isDarkMode
        ? 'z-10 !border-b !border-b-neutral-40 bg-black text-white'
        : 'z-10 !border-b !border-b-neutral-80 bg-white'
        } 
        sticky top-0 flex h-[72px] w-full items-center justify-between px-4 text-lg font-bold lg:px-24`}
      data-testid="landing-content"
    >
      <Lead className="items-center sm:flex">

        <a
          className={isDarkMode ? 'text-white' : 'text-black'}
          href="https://www.sbab.se/"
          aria-label="Länk till sbab.se"
        >
          <SBABLogo
            className={`mr-5 h-8 ${!isDarkMode ? 'n-logo' : ''}`}
            aria-label="SBAB Logga"
          />
        </a>
        
        <span className="ml-2">
          Kilowattkalkylen
        </span>
      </Lead>
      <div className="flex items-center font-medium sm:flex-row">
        <Link
          className={`!text-lg !font-thin !underline ${isDarkMode ? '!text-white' : '!text-black'}`}
          href="https://www.sbab.se/"
          aria-label="Länk till sbab.se"
        >
          Till sbab.se
        </Link>
      </div>
    </header>
  )
}
